module.exports = __webpack_public_path__ + "img/chubanwu_260819.149a47db.png";